import React from 'react'

export function PiProfileArrowIcon() {
  return (
    <svg
      width='8'
      height='4'
      viewBox='0 0 8 4'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.80506 0.195262C1.54471 -0.0650874 1.1226 -0.0650874 0.862254 0.195262C0.601905 0.455612 0.601905 0.877722 0.862254 1.13807L3.52892 3.80474C3.78927 4.06509 4.21138 4.06509 4.47173 3.80474L7.1384 1.13807C7.39875 0.877722 7.39875 0.455612 7.1384 0.195262C6.87805 -0.0650874 6.45594 -0.0650874 6.19559 0.195262L4.00033 2.39052L1.80506 0.195262Z'
        fill='white'
      />
    </svg>
  )
}
